module.exports = __webpack_public_path__ + "img/icon_lock_gray.6f6404bc.svg";